import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const istReducer = (state = {
    BarDiagrammIstUI: [],
    IstProgressUI: [],
    IstProgressYearUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_BarDiagrammIst_istReducer":
            return { ...state, BarDiagrammIstUI: action.value, isLoaded: true };
        case "RECEIVE_IstProgress_istReducer":
            return { ...state, IstProgressUI: action.value, isLoaded: true };
        case "RECEIVE_IstProgressYear_istReducer":
            return { ...state, IstProgressYearUI: action.value, isLoaded: true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, BarDiagrammIstUI: [], IstProgressUI: [], IstProgressYearUI: [], isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default istReducer;
